<template lang="pug">
  #inviteByLinkContainer
    h3
      v-card-title(class="convText text-center")
        | CONVIDAR POR LINK
    h4
      v-card-subtitle(
        class="text-center"
        style="color: #000;"
      )
        | Copie e cole o código abaixo para os integrantes da sua equipe.
        br
        | Você precisará aguardar o cadastro de cada integrante ser finalizado para iniciar a sua escala.

    v-card-text.card

      v-container

        v-row(align="center" style="padding-right: 7%; padding-left: 7%")

          v-col(cols="12" sm="12" md="12" class="column xs")

            h1(v-if="!loading && group" style="font-size: 19px").text-center
              | {{ inviteLinkUrl }}

            .button-area
              v-bottom-sheet(v-model="sheet" width="100%")
                template(v-slot:activator="{ on, attrs }")
                  input(type="hidden" id="copy-content" :value="copyContent")
                  v-btn(color="primary" height="50" class="btn ma-0" :disabled="loading" v-bind="attrs" v-on="on")
                    v-icon.mr-2 mdi-share
                    | COMPARTILHAR
                v-list
                  v-subheader Compartilhar por
                  v-list-item(v-for="(tile, index) in tiles" :key="tile.title" @click="tile.onClick({ handleCopy, copyContent, group })")
                    v-list-item-avatar
                      v-avatar(size="32px" tile)
                        img(:src="tile.img" :alt="tile.title")
                    v-list-item-title
                      | {{ tile.title }}

              v-btn(color="primary" class="btn ma-0" height="50" :loading="loading" :disabled="loading" @click="refreshInviteCode()")
                v-icon.mr-2 mdi-refresh
                | RENOVAR CÓDIGO

            .btn-avancar-area
              v-btn(color="primary" height="50" class="btn ma-0 mt-12" @click="finish()")
                | CONCLUIR

</template>

<script>
  import firebase from 'firebase/app'
  import 'firebase/database'

  import shareLink from '@/assets/images/share-link.png'
  import shareWhatsApp from '@/assets/images/share-whatsapp.png'
  import shareTelegram from '@/assets/images/share-telegram.png'
  import shareFacebook from '@/assets/images/share-facebook.png'
  import shareLinkedIn from '@/assets/images/share-linkedin.png'

  // import StringMixin from '@/mixins/string.mixin'

  export default {
    name: 'SendByLink',

    // mixins: [StringMixin],

    props: {
      groupID: {
        type: String,
        required: true,
      },
    },

    // data: () => ({

    data () {
      return {
        loading: true,
        group: null,
        inviteLink: null,
        sheet: false,
        tiles: [
          {
            img: shareLink,
            title: 'Copiar link',
            onClick: ({ handleCopy }) => {
              handleCopy(this.inviteLinkUrl)
            },
          },
          {
            img: shareWhatsApp,
            title: 'WhatsApp',
            onClick: ({ group }) => {
              const { VUE_APP_BASE_URL } = process.env
              const { groupID, idconvite } = group
              const t = Math.floor(Date.now() / 1000)
              const inviteURL = `${VUE_APP_BASE_URL}convite-grupo/${groupID}/${idconvite}?t=${t}`
              const text = `Olá! Clique no link para participar do grupo ${group.nome} no SOS Gestor.\n ${inviteURL}`
              const URL = ` https://wa.me/?text=${text}`
              window.open(URL, '_blank')
            },
          },
          {
            img: shareTelegram,
            title: 'Telegram',
            onClick: ({ group }) => {
              if (!group) { return '' }
              const { VUE_APP_BASE_URL } = process.env
              const { groupID, idconvite } = group
              const t = Math.floor(Date.now() / 1000)
              const inviteURL = `${VUE_APP_BASE_URL}convite-grupo/${groupID}/${idconvite}?t=${t}`
              const text = encodeURIComponent(`Olá! Clique no link para participar do grupo ${group.nome} no SOS Gestor.`)
              const URL = `https://t.me/share/url?url=${inviteURL}&text=${text}`
              window.open(URL, '_blank')
            },
          },
          {
            img: shareFacebook,
            title: 'Facebook (feed)',
            onClick: ({ group }) => {
              if (!group) { return '' }
              const { VUE_APP_BASE_URL } = process.env
              const { groupID, idconvite } = group
              const t = Math.floor(Date.now() / 1000)
              const inviteURL = `${VUE_APP_BASE_URL}convite-grupo/${groupID}/${idconvite}?t=${t}`
              const URL = `https://facebook.com/sharer/sharer.php?u=${inviteURL}`
              window.open(URL, '_blank')
            },
          },
          {
            img: shareLinkedIn,
            title: 'Linkedin (feed)',
            onClick: ({ group }) => {
              if (!group) { return '' }
              const { VUE_APP_BASE_URL } = process.env
              const { groupID, idconvite } = group
              const t = Math.floor(Date.now() / 1000)
              const inviteURL = `${VUE_APP_BASE_URL}convite-grupo/${groupID}/${idconvite}?t=${t}`
              const URL = `https://www.linkedin.com/shareArticle?mini=true&url=${inviteURL}`
              window.open(URL, '_blank')
            },
          },
        ],
      }
    },
    /* }), */

    computed: {
      inviteLinkUrl () {
        const { group } = this
        const { groupID, idconvite } = group
        const { VUE_APP_BASE_URL } = process.env
        const t = Math.floor(Date.now() / 1000)

        return `${VUE_APP_BASE_URL}convite-grupo/${groupID}/${idconvite}?t=${t}`
      },

      /* copyContentURL () {
        const { VUE_APP_BASE_URL } = process.env
        const t = Math.floor(Date.now() / 1000)
        const link = `${VUE_APP_BASE_URL}convite-grupo/${this.group.groupID}/${this.group.idconvite}?t=${t}`
        // [24/01/25] console.log('SendByLink > copyContentURL:', this.group, t, link)
        return link
      }, */

      copyContent () {
        const { group } = this
        if (!group) { return '' }
        const { VUE_APP_BASE_URL } = process.env
        const { groupID, idconvite } = group
        const t = Math.floor(Date.now() / 1000)
        return `🔴 Chamada: Clique ${VUE_APP_BASE_URL}convite-grupo/${groupID}/${idconvite}?t=${t} para fazer parte do grupo ${group.nome} no SOS Gestor.`
      },
    },

    watch: {
      group (value) {
        if (value && !value.idconvite) {
          this.refreshInviteCode()
        }
      },
    },
    // created () {
    mounted () {
      this.loadGroup()
    },
    methods: {
      finish () {
        // [24/01/25] console.log('SendByLink[finish]:', this.groupID)

        this.$router.push(`/admin/grupos/${this.groupID}/escalas`)
      },

      handleCopy (text) {
        const $this = this

        navigator.clipboard.writeText(text).then(function () {
          // [24/01/25] console.log(text)
          // alert('Link copiado com sucesso!')
          $this.sheet = false
        }, function () {
          alert('Não foi possível copiar o link')
        })

        // this.$clipboard(text)
        /* navigator.clipboard.writeText(text) */
        // alert('Link copiado com sucesso!')
        /* this.sheet = false */
      },

      handleShare (tile) {
        // [24/01/25] console.log({ tile })
      },

      loadGroup () {
        const $this = this

        const { groupID } = this

        this.loading = true

        firebase.database().ref(`grupos/${groupID}`).on('value', function (snapshot) {
          $this.loading = true
          if (snapshot && snapshot.val()) {
            $this.group = {
              groupID,
              ...snapshot.val(),
            }
          }
          $this.loading = false
        })
      },

      refreshInviteCode () {
        this.loading = true

        const $this = this

        const { groupID } = this.group

        const newInviteCode = ((+new Date()) + Math.random() * 1000).toString(36)

        firebase.database().ref(`grupos/${groupID}/idconvite`).set(newInviteCode, function (error) {
          // [24/01/25] console.log('refreshInviteCode[error]:', error)

          $this.loading = false
          /* if (error) {
            // ...
          } else {
            $this.loading = false
          } */
        })
      },
    },
  }
</script>

<style lang="scss" scoped>
#inviteByLinkContainer {
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;

  padding-top: 35px;
  // padding-bottom: 70px;
  padding-bottom: 25px;
  margin-top: 50px;
  margin-bottom: 15px;
  border-radius: 4px;
  background-color: #FFFFFF;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.20), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);

  color: rgba(0, 0, 0, 0.87);
}

.btn-avancar-area {
  // width: 800px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  @media(max-width: 600px){
    // width: 100%;
    justify-content: center;
  }

  /* @media(max-width: 960px){
    // width: 100%;
    justify-content: center;
  } */
}

.button-area {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 500px;
  margin-top: 50px;
  @media(max-width: 600px) {
      flex-direction: column;
      justify-content: space-around;
      width: 100%;
      height: 150px;
      align-content: space-around;
  }
}

.btn {
  font-weight: bold;
  width: 200px;
}

h1 {
  font-size: 40px;
}

.card {
  display: flex;
  flex: 1;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
}

.column {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.cardPage {
  background-color: #ffffff;
  border-radius: 10px;
  margin: 0;
}

.header {
  width: 100%;
  text-align: center;
}

.headerTitle {
  text-align: center;
  font-size: 25px;
}

.headerSubTitle {
  font-size: 15px;
  font-weight: 500;
  margin-top: 15px;
}

.convText {
  align-items: center;
  justify-content: center;
  font-weight: 400;
  font-size: 25px;
  @media(max-width: 600px){
    font-size: 25px;
  }
}

.shareContainer {
  /* background-color: red; */
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding-left: 120px;
  padding-right: 120px;
}

.email-container {
  // display: flex;
  // flex-direction: column;
  // align-items: center;
  // justify-content: center;
  // width: 50%;
  // padding: 0 60px;
}

.description {
  font-size: 15px;
  text-align: left;
}

.centerContainer {
  flex: 1;
  align-items: center;
  justify-content: center;
}

.textCenterContainer {
  font-size: 25px;
}

.linkContainer {
  flex: 2;
  align-items: center;
  justify-content: center;
}

.text-center {
  text-align: center;
}
</style>
